const MANAGE_ORDER_RETURN_LOADING = "MANAGE_ORDER_RETURN_LOADING";
const MANAGE_ORDER_RETURN_SUCCESS = "MANAGE_ORDER_RETURN_SUCCESS";
const MANAGE_ORDER_RETURN_ERROR = "MANAGE_ORDER_RETURN_ERROR";
export {
  MANAGE_ORDER_RETURN_LOADING,
  MANAGE_ORDER_RETURN_SUCCESS,
  MANAGE_ORDER_RETURN_ERROR,
};
